import Sidebar from "~/components/Sidebar/Sidebar";
import { CreateEntryContent, type CreateEntryContentProps } from "~/modules/dashboard/components/TimeTrackingCalendar/components/CreateEntryContent.tsx";

/**
 * The one create sidebar of the dashboard calendar. The clicked day is the date of both forms.
 *
 * It opens on "Zeiterfassung": time tracking is the most frequent use, and a user creates many trackings one after
 * another.
 *
 * A tab change drops the input of the other form: only the shown panel is mounted. The tab state lives below the
 * `<Sidebar>`, which unmounts it on close, so a new opening starts on "Zeiterfassung" with empty forms.
 *
 * A user without a staff member has no absences, so the sidebar shows no tabs, only the time tracking form.
 */
export function CreateEntrySidebar({ controller, absencePanelInputs }: CreateEntryContentProps) {
	return (
		<Sidebar closeOnOutsideClick={false}
				 open={controller.selectedDate !== null}
				 setOpen={controller.closeCreate}>
			<CreateEntryContent controller={controller}
								absencePanelInputs={absencePanelInputs} />
		</Sidebar>
	);
}
